// Generated by psc version 0.10.2
"use strict";
var Control_Semigroupoid = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Semigroupoid.purs");
var Category = function (__superclass_Control$dotSemigroupoid$dotSemigroupoid_0, id) {
    this["__superclass_Control.Semigroupoid.Semigroupoid_0"] = __superclass_Control$dotSemigroupoid$dotSemigroupoid_0;
    this.id = id;
};
var id = function (dict) {
    return dict.id;
};
var categoryFn = new Category(function () {
    return Control_Semigroupoid.semigroupoidFn;
}, function (x) {
    return x;
});
module.exports = {
    Category: Category, 
    id: id, 
    categoryFn: categoryFn
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-prelude/src/Control/Category.purs
// module id = 13
// module chunks = 0